import { render, staticRenderFns } from "./TopBarAvatarMenu.vue?vue&type=template&id=003f71b6"
import script from "./TopBarAvatarMenu.vue?vue&type=script&lang=js"
export * from "./TopBarAvatarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports